/**
 * What the POS operator is shown when something does not print (PRINTING_HANDOFF.md §7 step 3),
 * as v1 shows it: a missing default printer is the warning modal (`printHelper.printSale`); a ticket
 * or a label with no printer is the "configure a printer" toast (`printSaleTickets`,
 * `printItemLabelTemplate`, `polling.js`). Every other skip is silent, as in v1. Pure.
 */
import type { Skip } from "@rista/printing";

import type { CoreCopyKey } from "../copy/resolve";

export interface SkipNotice {
  as: "alert" | "toast";
  message: CoreCopyKey;
}

export function skipNotice(skip: Skip): SkipNotice | null {
  switch (skip.reason) {
    case "noDefaultPrinter":
      return { as: "alert", message: "printing.noDefaultPrinter" };
    case "noPrinterForTicket":
    case "noLabelPrinter":
    case "labelPrinterMissing":
      return { as: "toast", message: "printing.configurePrinter" };
    default:
      return null;
  }
}
